import { EffectiveCart } from 'interfaces/cart';
import { DiscountType } from 'interfaces/order';
import { useMemo } from 'react';
interface Input {
  effectiveCart?: EffectiveCart;
}

interface Output {
  toFulfillCouponMOV?: number;
}

/**
 * Calculate amount user needs to fulfill in order to apply coupon
 */
const useToFulfillCouponMOV = ({ effectiveCart }: Input): Output => {
  const toFulfillCouponMOV = useMemo(() => {
    if (
      effectiveCart &&
      effectiveCart?.itemsTotal >= 0 &&
      effectiveCart.errors?.discount?.type === DiscountType.COUPON &&
      effectiveCart.errors?.discount?.definition?.minimumBasketValue
    ) {
      return (
        effectiveCart.errors?.discount?.definition?.minimumBasketValue -
        effectiveCart?.itemsTotal / 100
      );
    } else {
      return undefined;
    }
  }, [effectiveCart]);

  return {
    toFulfillCouponMOV,
  };
};

export default useToFulfillCouponMOV;
